import React, { useState } from "react";
import { Box, Modal } from "@mui/material";
import Slide from "@mui/material/Slide";
import CircularProgress from "@mui/material/CircularProgress";

const overlayStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1300,
};

const myStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "560px",
  background: "var(--qv-bg-ffffff, #fff)",
  borderRadius: "12px",
  padding: "0",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  maxHeight: "85vh",
  overflow: "hidden",
};

const scrollContent = { padding: "20px", overflowY: "auto", flex: 1 };
const footer = {
  padding: "15px 20px",
  borderTop: "1px solid #ddd",
  background: "var(--qv-bg-ffffff, #fff)",
  borderBottomLeftRadius: "12px",
  borderBottomRightRadius: "12px",
};
const card = { marginTop: "15px", padding: "14px", background: "var(--qv-bg-f5f5f5, #f5f5f5)", borderRadius: "8px" };
const labelRow = { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" };
const copyBtn = {
  background: "var(--qv-bg-ffffff, #fff)",
  border: "1px solid var(--qv-brand, #0a64f9)",
  color: "var(--qv-brand-text, #0a64f9)",
  padding: "4px 10px",
  borderRadius: "4px",
  fontSize: "0.85em",
  cursor: "pointer",
};

const SupportEscalationModal = ({ open, onClose, isLoading, payload }) => {
  const data = payload?.data || {};
  const [copiedKey, setCopiedKey] = useState(null);

  const copyToClipboard = (value, key) => {
    if (!value) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(String(value));
    } else {
      const ta = document.createElement("textarea");
      ta.value = String(value);
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopiedKey(key);
    setTimeout(() => setCopiedKey(null), 1500);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-describedby="support-escalation-modal"
      className="delete-modal-outer-div"
      closeAfterTransition
    >
      <Slide direction="down" in={open} mountOnEnter unmountOnExit>
        <Box style={overlayStyles}>
          <Box className="delete-Box-modal qv-order-modal-panel" style={myStyles}>
            <div style={scrollContent}>
              <h3 style={{ marginBottom: "8px", fontWeight: 500 }}>Contact Quickvee Support</h3>
              <p style={{ color: "var(--qv-tx-555555, #555)", marginBottom: "10px", fontSize: "0.95em" }}>
                Quote the Uber Tracking ID below so the support agent can find this delivery.
              </p>

              {isLoading ? (
                <Box style={{ display: "flex", justifyContent: "center", padding: "30px" }}>
                  <CircularProgress sx={{ color: "var(--qv-tx-000000, #000000) !important" }} />
                </Box>
              ) : (
                <>
                  <div style={card}>
                    <p style={{ fontWeight: 500, marginBottom: "10px" }}>Support contact</p>

                    <div style={labelRow}>
                      <div>
                        <div style={{ fontSize: "0.8em", color: "var(--qv-tx-666666, #666)" }}>Phone</div>
                        <div style={{ fontWeight: 500 }}>
                          {data.support_phone ? (
                            <a href={`tel:${data.support_phone}`} style={{ color: "var(--qv-brand-text, #0a64f9)" }}>
                              {data.support_phone}
                            </a>
                          ) : (
                            "N/A"
                          )}
                        </div>
                      </div>
                      {data.support_phone && (
                        <button onClick={() => copyToClipboard(data.support_phone, "phone")} style={copyBtn}>
                          {copiedKey === "phone" ? "Copied" : "Copy"}
                        </button>
                      )}
                    </div>

                    <div style={labelRow}>
                      <div>
                        <div style={{ fontSize: "0.8em", color: "var(--qv-tx-666666, #666)" }}>Email</div>
                        <div style={{ fontWeight: 500 }}>
                          {data.support_email ? (
                            <a href={`mailto:${data.support_email}`} style={{ color: "var(--qv-brand-text, #0a64f9)" }}>
                              {data.support_email}
                            </a>
                          ) : (
                            "N/A"
                          )}
                        </div>
                      </div>
                      {data.support_email && (
                        <button onClick={() => copyToClipboard(data.support_email, "email")} style={copyBtn}>
                          {copiedKey === "email" ? "Copied" : "Copy"}
                        </button>
                      )}
                    </div>
                  </div>

                  <div style={card}>
                    <p style={{ fontWeight: 500, marginBottom: "10px" }}>Order reference</p>

                    {data.uber_tracking_id && (
                      <div style={labelRow}>
                        <div>
                          <div style={{ fontSize: "0.8em", color: "var(--qv-tx-666666, #666)" }}>Uber Tracking ID</div>
                          <div style={{ fontWeight: 500, wordBreak: "break-all" }}>{data.uber_tracking_id}</div>
                        </div>
                        <button
                          onClick={() => copyToClipboard(data.uber_tracking_id, "tracking_id")}
                          style={copyBtn}
                        >
                          {copiedKey === "tracking_id" ? "Copied" : "Copy"}
                        </button>
                      </div>
                    )}

                    {data.order_id && (
                      <div style={labelRow}>
                        <div>
                          <div style={{ fontSize: "0.8em", color: "var(--qv-tx-666666, #666)" }}>Order ID</div>
                          <div style={{ fontWeight: 500 }}>{data.order_id}</div>
                        </div>
                        <button onClick={() => copyToClipboard(data.order_id, "order_id")} style={copyBtn}>
                          {copiedKey === "order_id" ? "Copied" : "Copy"}
                        </button>
                      </div>
                    )}

                    {data.delivery_status && (
                      <div style={{ ...labelRow, marginBottom: 0 }}>
                        <div>
                          <div style={{ fontSize: "0.8em", color: "var(--qv-tx-666666, #666)" }}>Delivery status</div>
                          <div style={{ fontWeight: 500, textTransform: "capitalize" }}>
                            {(data.delivery_status || "").replaceAll("_", " ")}
                          </div>
                        </div>
                      </div>
                    )}

                    {data.uber_tracking_url && (
                      <div style={{ marginTop: "10px" }}>
                        <a
                          href={data.uber_tracking_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "var(--qv-brand-text, #0a64f9)" }}
                        >
                          Open Uber tracking page
                        </a>
                      </div>
                    )}

                    {!data.uber_tracking_id && !data.order_id && (
                      <p style={{ color: "var(--qv-tx-777777, #777)" }}>No Uber tracking reference available for this order.</p>
                    )}
                  </div>
                </>
              )}
            </div>

            <div style={footer}>
              <button
                onClick={onClose}
                style={{
                  background: "var(--qv-brand, #0a64f9)",
                  color: "#fff",
                  width: "100%",
                  padding: "10px 0",
                  borderRadius: "6px",
                  fontWeight: 500,
                }}
              >
                Close
              </button>
            </div>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};

export default SupportEscalationModal;
